import request from '@/utils/request'
// 查询考勤记录 列表
export function unlockRecordList (query) {
  return request({
    url: '/OA/unlockRecord/list',
    method: 'get',
    params: query
  })
}
// 查询考勤记录 分页
export function unlockRecordPage (query) {
  return request({
    url: '/OA/unlockRecord/list/page',
    method: 'get',
    params: query
  })
}
// 查询考勤记录统计 key
export function unlockRecordDayList (query) {
  return request({
    url: '/OA/unlockRecord/day/list',
    method: 'get',
    params: query
  })
}
// 查询考勤记录统计 key
export function unlockRecordStatistics (query) {
  return request({
    url: '/OA/unlockRecord/day/statistics',
    method: 'get',
    params: query
  })
}


// 查询补卡规则
export function repairRuleList (query) {
  return request({
    url: '/OA/repair/rule/list',
    method: 'get',
    params: query
  })
}

// 新增补卡规则
export function addRepairRule (data) {
  return request({
    url: '/OA/repair/rule',
    method: 'post',
    data,
  })
}
// 编辑补卡规则
export function updateRepairRule (data) {
  return request({
    url: '/OA/repair/rule',
    method: 'put',
    data,
  })
}
// 删除补卡规则
export function delRepairRule (id) {
  return request({
    url: "/OA/repair/rule/" + id,
    method: "delete",
  });
}
// 考勤组绑定补卡规则
export function addRepairRuleManagement (data) {
  return request({
    url: '/OA/repair/rule/management',
    method: 'post',
    data,
  })
}
// 修改 考勤组绑定补卡规则
export function updateRepairRuleManagement (data) {
  return request({
    url: '/OA/repair/rule/management',
    method: 'put',
    data,
  })
}
// 获取考勤组绑定补卡规则
export function repairRuleManagementBg (id) {
  return request({
    url: '/OA/repair/rule/management/' + id,
    method: 'get',
  })
}

//  员工设备绑定记录分页
export function sysUserPage (query) {
  return request({
    url: '/OA/unlockRecord/userList',
    method: 'get',
    params: query
  })
}

//  巡检点设置 列表
export function sysInspectionList (data) {
  return request({
    url: '/OA/sysInspection/list  ',
    method: 'post',
    data
  })
}
// 巡检点设置 新增
export function sysInspectionAdd (data) {
  return request({
    url: 'OA/sysInspection/add',
    method: 'post',
    data,
  })
}
// 修改 巡检点设置
export function sysInspectionUpdate (data) {
  return request({
    url: '/OA/sysInspection/update',
    method: 'post',
    data,
  })
}
// 巡检点设置 删除
export function sysInspectionDelete (data) {
  return request({
    url: 'OA/sysInspection/delete',
    method: 'post',
    data,
  })
}


//  巡检记录 列表
export function sysInspectionRecordList (data) {
  return request({
    url: '/OA/sysInspectionRecord/list',
    method: 'post',
    data
  })
}
// 巡检记录 删除
export function sysInspectionRecordDelete (data) {
  return request({
    url: 'OA/sysInspectionRecord/delete',
    method: 'post',
    data,
  })
}

//  日报 列表
export function workLogList (query) {
  return request({
    url: '/OA/workLog/list',
    method: 'get',
    params: query
  })
}

// 日报 删除
export function workLogDelete (data) {
  return request({
    url: 'OA/workLog/delete',
    method: 'post',
    data,
  })
}

//  巡检模板查询 列表
export function listTemplate(query) {
  return request({
    url: '/OA/system/inspectionTemplate/list',
    method: 'get',
    params: query
  })
}
